import reusedStyles from "../styles.module.scss";
import styles from "./styles.module.scss";
import YouTubeVideo from "./youtube";

export default function Video({ id, label }: { id: string, label: string }) {
	// const id = "CqZgd6-xQl8";
	return (
		<div className={`customContainer`}>
			<div className={styles.container}>
				<h2 className={reusedStyles.heading}>{label}</h2>
				{/* <VideoRow mobileUrl="" desktopUrl="https://www.youtube.com/watch?v=INbgG9M0WYE&pp=ygURZGFmdCBwdW5rIHZveWFnZXI%3D" /> */}
				<YouTubeVideo id={id} time={10} />
			</div>
		</div>
	);
}